import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons/faSpinnerThird'
import { faSpinner } from '@fortawesome/pro-duotone-svg-icons/faSpinner'
import Skeleton from '@softwaredev_cegeka/stix-core/dist/components/Skeleton'

import styles from './loader.module.scss'

export default function Loader({
    inline,
    className,
    children,
    size = '1x',
    ...rest
}) {
    return (
        <div
            role={'status'}
            className={cx(styles.loadingOverlay, className)}
            {...rest}
        >
            <div className="d-flex">
                <FontAwesomeIcon
                    className={cx(styles.loaderIcon, {
                        [styles.loaderInline]: inline,
                    })}
                    icon={faSpinnerThird}
                    spin
                    size={size}
                />
            </div>
            {children}
        </div>
    )
}

export function RouteLoader() {
    return (
        <Loader
            className={styles.routeLoader}
            aria-label={'Loading page...'}
            size="6x"
        />
    )
}

export const TextLoader = ({ lines = 1, ...rest }) => {
    return (
        <p role={'status'}>
            <Skeleton count={lines} {...rest} />
        </p>
    )
}

export const TitleLoader = props => {
    return (
        <Skeleton.Theme
            baseColor={'#CBD7DF'}
            height={'2rem'}
            borderRadius={'15px'}
        >
            <p role={'status'}>
                <Skeleton {...props} />
            </p>
        </Skeleton.Theme>
    )
}

TitleLoader.propTypes = {
    width: PropTypes.number,
}

export const AnimatedLineLoader = () => {
    return (
        <div className={styles.animatedLineLoader}>
            <div className={styles.element} />
        </div>
    )
}

export const AnimatedSpinner = () => {
    return (
        <div
            role={'status'}
            aria-label={'Loading data...'}
            className={styles.animatedSpinner}
        >
            <FontAwesomeIcon icon={faSpinner} pulse={true} />
        </div>
    )
}
